export enum URL_ACTIONS {
    BACK = 'back',
    API = 'api',
    BINGO888 = '888bingo',
    LINK = ''
}

export const getUrlAction: Function = function(url = ''): string {
    if (url.includes(URL_ACTIONS.BACK)) {
        return URL_ACTIONS.BACK;
    } else if (url.includes(URL_ACTIONS.API)) {
        return URL_ACTIONS.API;
    } else if (url.includes(URL_ACTIONS.BINGO888)) {
        return URL_ACTIONS.BINGO888;
    } else {
        return URL_ACTIONS.LINK;
    }
};